import {useCallback} from 'react';

import {CHOOSE_CARD_THEME_EVENTS} from '@/app/auth/events/ChooseCardThemeEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewOnboardingSelectCardTheme = useCallback(() => {
    trackEvent(CHOOSE_CARD_THEME_EVENTS.VIEW_ONBOARDING_SELECT_CARD_THEME, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  const trackSelectOnboardingChooseCardTheme = useCallback(
    (themeSelected: string) => {
      trackEvent(CHOOSE_CARD_THEME_EVENTS.SELECT_ONBOARDING_CHOOSE_CARD_THEME, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        Banking: {
          card: {
            theme: {
              name: themeSelected ?? '',
            },
          },
        },
      });
    },
    [trackEvent],
  );

  const trackViewOnboardingModalPreviewCardTheme = useCallback(
    (themeSelected: string) => {
      trackEvent(
        CHOOSE_CARD_THEME_EVENTS.VIEW_ONBOARDING_MODAL_PREVIEW_CARD_THEME,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          Banking: {
            card: {
              theme: {
                name: themeSelected ?? '',
              },
            },
          },
        },
      );
    },
    [trackEvent],
  );

  return {
    trackViewOnboardingSelectCardTheme,
    trackSelectOnboardingChooseCardTheme,
    trackViewOnboardingModalPreviewCardTheme,
  };
};
